// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"2a1543b9","161":"aa0a1a0b","381":"e303b2d9","454":"fa055c1c","465":"a9622457","616":"ea6c3d0e","821":"4989f460"}[chunkId] + ".chunk.js";
};